import React, { useEffect, useState } from 'react';
import './Opportunities.css'; 

const API_URL = process.env.REACT_APP_API_URL;

export default function Opportunities() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/jobs`)
      .then(res => res.json())
      .then(data => {
        setJobs(data);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    document.title = 'Join our Team';
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <div className="page-banner" style={{ backgroundImage: 'url(/opportunities_banner.png)' }}>
        <h1 className="page-banner-title" id="opportunities-banner-heading">
          Opportunities
        </h1>
      </div>
      <section className="opportunities-page-wrapper" aria-labelledby="working-at-inalab-heading">
        <div id="grnhse_app">
          <iframe
            id="grnhse_iframe"
            title="Greenhouse Job Board"
            src="https://job-boards.greenhouse.io/embed/job_board?for=inalabconsulting"
            width="100%"
            height="1988"
            frameBorder="0"
            scrolling="no"
            allow="geolocation"
            style={{ minHeight: '800px', width: '100%' }}
          ></iframe>
        </div>
      </section>
    </>
  );
} 